import React from 'react';
import '../mobile.css';

// Mirrors the mobile app's Switch styling (trackColor false: #E53935 red, true: #4CAF50 green).
const ToggleSwitch = ({ checked, onChange }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    onClick={(e) => {
      e.stopPropagation();
      onChange();
    }}
    className={`m-toggle ${checked ? 'on' : 'off'}`}
  >
    <span className="m-toggle-thumb" />
  </button>
);

export default ToggleSwitch;
